import React, { useEffect, useState } from 'react';
import { getClasses, getFilteredClasses } from '../apis/bys';
import Results from './Results';
import Picker from './Picker';
import './App.css';

const moods = ['Relaxing', 'Strong', 'Meditation', 'Flowy', 'Anything'];
const durations = [15, 20, 25, 30, 45, 60];

const App = () => {
  const [duration, setDuration] = useState(durations[3]);
  const [mood, setMood] = useState(moods[0]);
  const [classList, setClassList] = useState([]);
  const [randomized, setRandomized] = useState(false);
  const [oldList, setOldList] = useState(classList);
  const [findClicked, setFindClicked] = useState(false);
  const [randomClass, setRandomClass] = useState([]);
  const [masterList, setMasterList] = useState([]);

  useEffect(() => {
    const getAllClasses = async () => {
      const masterClasses = await getClasses();
      setMasterList(masterClasses);
    };
    getAllClasses();
  }, []);

  const onFindClick = () => {
    const classes = getFilteredClasses(masterList, duration, mood);
    setClassList(classes);
    setOldList(classes);
    setFindClicked(true);
    setRandomized(false);
  };

  const onPickerClick = () => {
    const rand = Math.floor(Math.random() * classList.length);
    const random = classList[rand];
    setRandomClass([random]);
    setRandomized(true);
  };

  // eslint-disable-next-line eqeqeq
  const classMatch = oldList.length == 1 ? 'class matches' : 'classes match';

  return (
    <div className="sans-serif pt0 pl4 pr4 center w-80-l w-100-m w-100-s">
      <div className="w-90 w-100-m w-100-s bg-blue mb4 pt4 center header">
        <img
          className="w5 mw-50 db center mb0 pt2"
          src="byslogo.png"
          alt="logo"
        />
        <h4 className="white tc mt0 f3 pb2 oswald normal">Class Picker</h4>
      </div>
      <div className="w-50-l w-80-m w-80-ns center">
        <div className="tj pl2 pr2">
          Hi! I'm the Bad Yogi Studio Class Picker. If you don't know what class
          to do next I'm here to help. Just tell me what you're looking for and
          I'll do the rest. By the way, I was created by the amazing Bad Yogi
          Ashley dePreaux. So let her know she's awesome next time you see her
          around.
        </div>
        <h2 className="tc">Tell me what you're looking for:</h2>
        <div className="tc pb4">
          I have{' '}
          <select
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          >
            {durations.map((dur) => {
              return (
                <option value={dur} key={dur}>
                  {dur.toString()}
                </option>
              );
            })}
          </select>{' '}
          minutes.
        </div>
        <div className="tc">
          {`I'm in the mood for `}
          <select value={mood} onChange={(e) => setMood(e.target.value)}>
            {moods.map((mood) => (
              <option value={mood} key={mood}>
                {mood}
              </option>
            ))}
          </select>
          <button
            className={`tc tracked bg-purple white bw0 br4 pa2 mt4 mb0 center db w-50 mw-80 ttu`}
            onClick={onFindClick}
          >
            Find a class
          </button>
          <h6 className="f6 db pt1">
            {findClicked
              ? `${oldList.length} ${classMatch} your criteria`
              : null}
          </h6>
        </div>
      </div>
      {findClicked && classList.length > 1 ? (
        <Picker onPickerClick={onPickerClick} randomized={randomized} />
      ) : null}
      {classList.length > 0 ? (
        <Results
          classes={randomized && classList.length > 1 ? randomClass : classList}
        />
      ) : null}
    </div>
  );
};

export default App;
